const BaseView = require('../components/common/common-component');
const KwlsView = require('./kwls');
const MnsView = require('./mns');
const AnalyticsDecorate = require('../../../analytics/decorate');
const template = require('./kw-template.hbs');

module.exports = AnalyticsDecorate(require('./analytics/view'), BaseView.extend({
  type: 'kwls',

  isAlreadyThere: function () {
    return !!this.$el.find('.tab-content.kwls').length;
  },

  render: async function () {
    await BaseView.prototype.render.call(this);
    this.$headerLinks.filter('[data-key=kwls]').trigger('click');
  },

  refresh: function () {
    BaseView.prototype.refresh.call(this);
    this.$el.find('.search-container').removeClass('disabled');
    const activeImagesTab = this.$el.find('.header').find('.active[data-key=images]');

    activeImagesTab.length && activeImagesTab.removeClass('active').trigger('click');
  },

  initKwlsView: function () {
    this.registerTabView('kwls', new KwlsView({ el: this.initTabView('kwls') }));
  },

  initMnsView: function () {
    this.registerTabView('mns', new MnsView({ el: this.initTabView('mns') }));
  },

  initTabView: function (type) {
    const $view = this.$el.find('.tab-content > .' + type);
    $view.html(template({
      type: type,
      isKwls: type === 'kwls'
    }));

    return $view;
  }
}));
